/**
 * Builds the payload used to send chat messages to the agent.
 * Same shape for both HTTP (POST /_chat/tb) and WebSocket (/_chat/message).
 * Aligns with arbitium_loop payload_chat_message and console WebSocketButton/useWebSocket.
 */

export interface ChatMessagePayloadBase {
  action: 'chat_message';
  portfolio: string;
  org: string;
  entity_type: string;
  entity_id: string;
  thread: string | null;
  next?: string | null;
  core?: string;
  case_group?: string;
  [key: string]: unknown;
}

/**
 * Builds the base payload for a chat message (without the user message text).
 * Add `data: message` when sending. Used by both HTTP and WebSocket.
 */
export function buildChatMessagePayload(params: {
  portfolio: string;
  org: string;
  entity_type: string;
  entity_id: string;
  thread: string | null;
  next?: string | null;
  core?: string;
  case_group?: string;
}): ChatMessagePayloadBase {
  return {
    action: 'chat_message',
    portfolio: params.portfolio,
    org: params.org,
    entity_type: params.entity_type,
    entity_id: params.entity_id,
    thread: params.thread,
    ...(params.next != null && { next: params.next }),
    ...(params.core && { core: params.core }),
    ...(params.case_group && { case_group: params.case_group }),
  };
}

/** Default core for remediation agent (arbitium_loop uses this). */
export const REMEDIATION_AGENT_CORE = 'pes/remediation_agent';

/** Default case_group for remediation chat. */
export const REMEDIATION_CASE_GROUP = 'remediation';
